import AltProfilePic from "../Assets/profileIcon.png";
import { useNavigate } from "react-router";

const PatientCard = ({ patientInfo }) => {
    const navigate = useNavigate();

    const patientPageNavigate = () => {
        navigate(`/patient/${patientInfo.id}`);
    };

    

    const handleImgError = (e) => {
        e.target.onerror = null;
        e.target.src = AltProfilePic;
    };

    return (
        <div
            onClick={patientPageNavigate}
            className="cursor-pointer bg-white rounded-xl shadow-md hover:shadow-lg transition-all duration-300 p-5 flex flex-col gap-4 border border-gray-100 hover:border-gray-200 w-full max-w-sm"
        >
            {/* Profile Section */}
            <div className="flex items-center gap-4">
                <img
                    className="w-16 h-16 rounded-full object-cover border border-gray-200"
                    src={patientInfo.image_url ?? AltProfilePic}
                    alt="Profile"
                    onError={handleImgError}
                />
                <div>
                    <p className="text-lg font-semibold text-gray-800">
                        {patientInfo.first_name} {patientInfo.last_name}
                    </p>
                    <span className="text-sm text-gray-400">Patient ID: {patientInfo.id}</span>
                    {patientInfo.gender && (
                        <p className="text-sm text-gray-500">
                            Gender: {patientInfo.gender}
                        </p>
                    )}
                    {patientInfo.phone_no && (
                        <p className="text-sm text-gray-500">
                            Contact: {patientInfo.phone_no}
                        </p>
                    )}
                </div>
            </div>

            {/* Note Section */}
            <div
                className="bg-gray-50 p-3 rounded-lg text-sm text-gray-700"
                title={patientInfo.note || "Note is empty, add one for reference."}
            >
                <strong>Note:</strong>{" "}
                {patientInfo.note ? (
                    <span className="line-clamp-2">
                        {patientInfo.note}
                    </span>
                ) : (
                    <span className="text-gray-400 italic">
                        Note is empty, add one for reference.
                    </span>
                )}
            </div>

            {/* Date Info */}
            <div className="flex justify-between text-xs text-gray-400">
                <span>
                    Added: {new Date(patientInfo.created_at).toLocaleDateString()}
                </span>
                <span>
                    Updated: {new Date(patientInfo.updated_at).toLocaleDateString()}
                </span>
            </div>
        </div>
    );
};

export default PatientCard;
